module.exports = __webpack_public_path__ + "static/media/like.c4dab335.svg";